export enum SnmpSecurityLevel {
    NOAUTHNOPRIV,
    AUTHNOPRIV,
    AUTHPRIV
}